export function ElearningSettingsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/elearning-settings.svg'"></ng-include>`
    }
}